import { QUERY } from '@sonar-software/sonar-ts-constants';
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export const LoginRedirectRoute: React.FC = () => {
	const { pathname, search } = useLocation();

	let redirectTarget = '/';

	if (pathname !== '/') {
		const searchParams = new URLSearchParams(search);

		searchParams.append(QUERY.TARGET_ROUTE, pathname);

		redirectTarget = `/?${searchParams.toString()}`;
	}

	return <Navigate to={ redirectTarget } />;
};
